// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBuqN2FYKHEizr-XK7dAL0po7k6aLxEF_o",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "pnic-scores.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "pnic-scores",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "pnic-scores.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "920968833092",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:920968833092:web:b033238ab60fa544e2f411",
  // Add these fields for better compatibility
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://pnic-scores-default-rtdb.firebaseio.com",
};

// Debug: Log Firebase configuration status
console.log('🔍 Firebase Configuration:');
console.log('Environment:', process.env.NODE_ENV);
console.log('Project ID:', firebaseConfig.projectId);
console.log('Using environment variables:', process.env.REACT_APP_FIREBASE_API_KEY ? '✅' : '❌ (using fallbacks)');

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const db = getFirestore(app);
export { storage, db, app };
